import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _callSuper2(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import GameInterface from './index';
import store from '../../state/store';
import { setGameState } from '../../state/actions/game';
import utils from '../../utils';
import { EVENT_EMITTER_TYPE, FTUE_STEPS_KEYS, PLATFORM } from '../../constants';
import { setSpinEvent } from '../../state/slices/spinEvent/spinEvent';
import SPIN_PHASE from './helpers/spinPhases';
import { sendFtueEvent } from '../../lib/analytics/ftueLogger';
import { FTUE_EVENT_TYPES } from '../../constants';
import Emitter from '../../services/EmitterService';
import { ACTION_COMMANDS_FEATURE_GROUP, ACTION_COMMANDS_TYPE } from '../ActionCommandsInterface/constants';
import { getText, TEXT_KEY } from '../../utils/localization';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Logger from '../../lib/analytics/logger';

var keyMirror = require('keymirror');

var events = keyMirror({
  /** @type {Boolean} sound on/off */
  SOUND: false,

  /** @type {String} informational text string about program state */
  STATE: null,

  /** @type {String} application-dependent error code */
  ERROR_CODE: null,

  /** @type {String} human-readable error description */
  ERROR_DESCRIPTION: null,

  /** ERR_LOGINFAILED | CommandID.SERVERVERSION: game can't continue; either login failed or wrong version */
  CLOSE: null,

  /** @type {Number} `0`-`100` describing loading progress */
  LOADING_PROGRESS: null,

  /** @type {String} build version of client */
  CLIENTVERSION: null,

  /** @type {String} reason for client disconnect by server */

  /** - 1: The user was inactive for too long */
  KICK_REASON: null,
  MINBET: null,
  MAXBET_ON_MAXLINES: null,

  /** @type {Boolean} music on/off */
  MUSIC: false,

  /** @type {Number} player can't spin b/c their balance is lower than current total bet (this is only fired when balance hits 0, at least for roulette and blackjack) */
  TOOLITTLEMONEY: null,

  /** @type {Number} id of current game (Greentube's ID, not ours) */
  GAME_ID: null,

  /** @type {String} currency type eg EUR or GBP */
  CURRENCY: null,

  /** @type {Number} current player balance */
  BALANCE: null,

  /** @type {Number} last amount player won and collected */
  PAID: null,

  /** @type {Number} current total bet */
  BET: null,

  /** @type {Number} Win amount */
  INCREASEWIN: null,

  /**
   * @type {Number}
   * also the current total bet... but for blackjack, roulette, and maybe others... who the heck really knows
   * Seems like this is fired when a slot machine spins with the bet amount -- useful for client side xp
   */
  INCREASESTAKE: null,

  /** @type {null} GUI of game is ready. used for loading completion */
  GAMEGUICREATED: null,

  /**
   * @type {String} current state of the game. possible values:
   * - `READY`, `ERROR`, `LOBBY`, `SPECTATOR`, `SPINNING`,
   * - `CLOSED`, `LOADING`, `CONNECTING`, `PAYIN`, `WINS`,
   * - `DECIDE_GAMBLE`, `GAMBLE`, `BONUS_GAME`, `SUPER_GAME`
   */
  GAME_MODE: null,

  /** @type {Number} number of free bets during free spins */
  FREE_BETS: null,

  /** @type {Boolean} autoplay has been started, or not */
  AUTOPLAY: null,

  /**
   * @type {String} list of buttons describing their state. list is first separated by a ; and
   * each part is again separated by a colon :. each pair is a string naming the button
   * and an integer describing the state.
   * - `0`: disabled
   * - `1`: enabled
   * - `2`: enabled and blinking
   */
  BUTTONSTATE: null,

  /** @type {String} `MOVEIN` or `MOVEOUT`, sent when paytable animation starts */
  PAYTABLE: null,

  /** @type {String} `HIDE` or `SHOW`. either the balance is hidden or shown. */
  HIDE_CREDIT: null,

  /**
   * @type {String} generic data which can be sent from the backend to the client.
   * integration-specific.
   */
  CLIENT_DATA: null,

  /** sends the info relating to a spin or other game action, */
  GAMEACTIONDATA: null,

  /** Idle Mode */
  ILLUMINATOR_MODE: null,

  /** Collect Mode */
  UNCOLLECTED_WIN: null
});

var GreenTube = /*#__PURE__*/function (_GameInterface) {
  /**
   * GameInterface constructor
   * @param {Object} args
   * @param {import("../Constants").BetInfo} args.BetInfo
   * @param {Function} args.ExitFunc
   */
  function GreenTube(args) {
    var _this2;

    _classCallCheck(this, GreenTube);

    _this2 = _callSuper2(this, GreenTube, [args]);

    _this2.kvpParserEvent = function (event) {
      var _store$getState = store.getState(),
          _store$getState$playe = _store$getState.playerInfo,
          soundEffects = _store$getState$playe.soundEffects,
          music = _store$getState$playe.music,
          playerId = _store$getState$playe.playerId,
          gameId = _store$getState.gameInfo.gameId,
          ftueStep = _store$getState.currentOnboarding.ftueStep,
          _store$getState$lastS = _store$getState.lastSpinEvents.balanceAfter,
          balance = _store$getState$lastS === void 0 ? null : _store$getState$lastS;

      if (soundEffects !== _this2.currentSoundSetting) {
        _this2.setSound(soundEffects);
      }

      if (music !== _this2.currentMusicSetting) {
        _this2.setMusic(music);
      }

      switch (event.name) {
        case events.LOADING_PROGRESS:
          {
            if (event.value === 100 && !_this2._sentSound) {
              _this2._sentSound = true;

              _this2.setSound(false);

              _this2.setMusic(false);
            }

            break;
          }

        case events.GAME_MODE:
          {
            if (event.value === 'READY' && ftueStep === FTUE_STEPS_KEYS.SHOW_IN_GAME) store.dispatch(setGameState('Ready'));

            if (event.value === 'READY' && !_this2._betInfoSent) {
              _this2.sendAnalyticEvent();

              _this2.sendKeyValuePair('BET', _this2._betInfo.defaultBet);

              setTimeout(function () {
                _this2.setSound(_this2.soundSettings.soundEffects);

                _this2.setMusic(_this2.soundSettings.music);
              }, 1000);
              _this2._betInfoSent = true;
            }

            if (event.value === 'READY' && ftueStep == FTUE_STEPS_KEYS.FINISHED_AND_SHOW_POPUP) {
              _this2.setOnboardingTutorialComplete();

              _this2.checkFtueStep(false);
            }

            if (event.value === 'CLOSED') {
              console.log('game sent close command, closing');

              _this2.exitFunc();
            }

            if (event.value === 'SPINNING') {
              if (!ftueStep) return;

              if (ftueStep === FTUE_STEPS_KEYS.CLICKED_ON_SPINNER) {
                sendFtueEvent(FTUE_EVENT_TYPES.GAME_TUTORIAL_NEXT_STEP, {
                  step: ftueStep
                });

                _this2.checkFtueStep(true, FTUE_STEPS_KEYS.FINISHED_AND_SHOW_POPUP);
              }
            }

            break;
          }

        case events.FREE_BETS:
          {
            var freeGames = parseInt(event.value);

            if (freeGames > 1) {
              _this2.isInFreeGames = true;
            }

            if (freeGames == 1) {
              _this2.isInFreeGames = false;
            }

            break;
          }

        case events.INCREASESTAKE:
          {
            _this2.currentBet = parseInt(event.value);

            _this2.AddSpinXP(event.value);

            store.dispatch(setSpinEvent({
              playerId: playerId,
              createdTimestamp: Date.now(),
              spinPhase: SPIN_PHASE.WAGE,
              gameId: gameId,
              amount: _this2.currentBet
            }));
            break;
          }

        case events.AUTOPLAY:
          {
            break;
          }

        case events.BET:
          {
            _this2.currentBet = parseInt(event.value);
            break;
          }

        case events.INCREASEWIN:
          {
            var win = parseInt(event.value);

            if (!_this2.isInFreeGames) {
              store.dispatch(setSpinEvent({
                playerId: playerId,
                createdTimestamp: Date.now(),
                spinPhase: SPIN_PHASE.WIN,
                gameId: gameId,
                amount: _this2.cumulativeWin + win
              }));
              _this2.cumulativeWin = 0;
            }

            if (_this2.isInFreeGames) {
              _this2.cumulativeWin += win;
            }

            if (win >= 10 * _this2.currentBet && utils.getPlatform() !== PLATFORM.WEB) _this2.showRateUsScreen();
            break;
          }

        case events.PAID:
          {
            break;
          }

        case events.BALANCE:
          {
            _this2.currentBalance = parseInt(event.value);
            store.dispatch(setSpinEvent({
              balanceBefore: balance ? balance : event.value,
              balanceAfter: event.value
            }));

            _this2.syncCoinsBalance(event.value);

            break;
          }

        case events.ILLUMINATOR_MODE:
          {
            if (event.value == 'IdleMode') {
              if (_this2.currentBalance < _this2.currentBet) {
                _this2.showOutOfCoinsScreen();
              }
            }

            break;
          }

        case events.ERROR_DESCRIPTION:
          {
            var errorDescription = JSON.stringify(event.value);

            _this2.sendErrorCreatedEvent(errorDescription);

            break;
          }

        case events.UNCOLLECTED_WIN:
          {
            if (ftueStep === FTUE_STEPS_KEYS.FINISHED_AND_SHOW_POPUP) {
              _this2.setOnboardingTutorialComplete();

              _this2.checkFtueStep(false);
            }

            break;
          }

        default:
          {
            console.log('Unhandled event.');
            break;
          }
      }
    };

    _this2.setOnboardingTutorialComplete = function () {
      var _actionCommands$paylo;

      var _store$getState2 = store.getState(),
          ftueStep = _store$getState2.currentOnboarding.ftueStep,
          actions = _store$getState2.actionCommands.actions;

      var actionCommands = actions[0];
      Logger.sendEvent(EVENT_TYPES.TUTORIAL_COMPLETE, {
        type: 'gameTutorial'
      });
      sendFtueEvent(FTUE_EVENT_TYPES.GAME_TUTORIAL_COMPLETE, {
        step: ftueStep,
        isFtueFlow: (actionCommands === null || actionCommands === void 0 ? void 0 : (_actionCommands$paylo = actionCommands.payload) === null || _actionCommands$paylo === void 0 ? void 0 : _actionCommands$paylo.featureGroup) === ACTION_COMMANDS_FEATURE_GROUP.FTUE
      });

      if (actionCommands) {
        var _actionCommands$gameT, _actionCommands$gameT2, _actionCommands$gameT3, _actionCommands$gameT4, _actionCommands$paylo2;

        Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
          actionType: ACTION_COMMANDS_TYPE.NOTIFY_TRIGGER_PROCESSED_REQUEST,
          data: {
            triggerExecution: actionCommands === null || actionCommands === void 0 ? void 0 : (_actionCommands$gameT = actionCommands.gameTutorial) === null || _actionCommands$gameT === void 0 ? void 0 : (_actionCommands$gameT2 = _actionCommands$gameT.onCompleteAction) === null || _actionCommands$gameT2 === void 0 ? void 0 : _actionCommands$gameT2.triggerExecution,
            payload: actionCommands === null || actionCommands === void 0 ? void 0 : (_actionCommands$gameT3 = actionCommands.gameTutorial) === null || _actionCommands$gameT3 === void 0 ? void 0 : (_actionCommands$gameT4 = _actionCommands$gameT3.onCompleteAction) === null || _actionCommands$gameT4 === void 0 ? void 0 : _actionCommands$gameT4.payload,
            isFtueFlow: (actionCommands === null || actionCommands === void 0 ? void 0 : (_actionCommands$paylo2 = actionCommands.payload) === null || _actionCommands$paylo2 === void 0 ? void 0 : _actionCommands$paylo2.featureGroup) === ACTION_COMMANDS_FEATURE_GROUP.FTUE
          }
        });
        Emitter.emit(EVENT_EMITTER_TYPE.ACTION_COMMANDS, {
          actionType: ACTION_COMMANDS_TYPE.CLEAR_ACTION_COMMAND
        });
      }
    };

    _this2.jsonParserEvent = function (event) {
      if (!event.event) return;
      var ftueStep = store.getState().currentOnboarding.ftueStep;
      if (!ftueStep) return;
      var jsonEvent = event.event;

      if (ftueStep === FTUE_STEPS_KEYS.SHOW_IN_GAME && jsonEvent.name === 'neonconsoleinit' && !_this2.spinnerButtonPosition) {
        _this2.spinnerButtonPosition = jsonEvent.spin_button;
      }

      if (ftueStep === FTUE_STEPS_KEYS.SHOW_IN_GAME && jsonEvent.name === 'splashScreenClose') {
        var wWidth;
        var wHeight;
        var position;
        var message = {
          message: getText(TEXT_KEY.FTUE_TAP_FIRST_SPIN),
          position: 'left'
        };

        if (utils.getPlatform() === 'web') {
          wWidth = window.innerWidth;
          wHeight = window.innerHeight;
          position = {
            x: wWidth * 0.755,
            y: wHeight * 0.37,
            width: wWidth * 0.14,
            height: wWidth * 0.14,
            transparent: false,
            isCircle: true
          };
        } else {
          wWidth = _this2._dimension.get('screen').width;
          wHeight = _this2._dimension.get('screen').height;
          position = {
            x: _this2._deviceInfo.isTablet() ? wWidth * 0.85 : wWidth * 0.7,
            y: _this2._deviceInfo.isTablet() ? wHeight * 0.39 : wHeight * 0.37,
            width: _this2._deviceInfo.isTablet() ? wWidth * 0.15 : wWidth * 0.18,
            height: _this2._deviceInfo.isTablet() ? wWidth * 0.15 : wWidth * 0.18,
            transparent: false,
            isCircle: true
          };
        }

        sendFtueEvent(FTUE_EVENT_TYPES.GAME_TUTORIAL_NEXT_STEP, {
          step: ftueStep
        });

        _this2.checkFtueStep(true, FTUE_STEPS_KEYS.CLICKED_ON_SPINNER, position, message);
      }
    };

    _this2.lastKnownBetAmount = 0;
    _this2.currentBalance = 0;
    _this2.currentBet = 0;
    _this2.currentSoundSetting = false;
    _this2.currentMusicSetting = false;
    _this2.isInFreeGames = false;
    _this2.spinnerButtonPosition = null;
    _this2.cumulativeWin = 0;
    return _this2;
  }
  /**
   * GreenTube Event Handler
   * @param {import("./helpers/parseEvent").ParsedEvent} event
   */


  _inherits(GreenTube, _GameInterface);

  return _createClass(GreenTube, [{
    key: "setSound",
    value: function setSound(value) {
      this.sendKeyValuePair('SOUND', value);
      this.currentSoundSetting = value;
    }
  }, {
    key: "setMusic",
    value: function setMusic(value) {
      this.sendKeyValuePair('MUSIC', value);
      this.currentMusicSetting = value;
    }
  }]);
}(GameInterface);

export default GreenTube;